import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=50aa3cd6&scoped=true"
import script from "./Supplier.vue?vue&type=script&lang=js"
export * from "./Supplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aa3cd6",
  null
  
)

export default component.exports